import React from 'react'
import { Route } from 'react-router'
import Home from '../../containers/Home'
import Order from '../../containers/Order'
import Scaning from '../../containers/Scaning'
import RedirectDashboard from '../../containers/DashboardDraft/Redirect'

export default function PermissionRoute({ children, element: Element, permissions, ...rest }) {
  function getRootPath(location) {
    const paths = location.pathname.split('/')
    return paths.pop()
  }
  return (
    <Route
      {...rest}
      render={({ location }) => {
        const path = getRootPath(location)
        if (path === '') {
          if (permissions.includes('dashboard')) {
            return permissions.includes('dashboard') && <RedirectDashboard />
          } else if (permissions.includes('order')) {
            return permissions.includes('order') && <Order />
          } else if (permissions.includes('Scaning')) {
            return permissions.includes('Scaning') && <Scaning />
          } else {
            return <Home />
          }
        } else {
          return permissions.includes(path) && <Element />
        }
      }}
    />
  )
}
